import { Row, Tabs, TabsProps } from "melco-ui";
import { DesignTokens } from "melco-ui";
import styled from "styled-components";
import { MachineStatusView } from "./MachineStatusView";
import { ReportingMelcoMachineStatisticsModelsViewListItem } from "melco-shared-logic";
import { useState } from "react";

export const FullWidthRow = styled(Row)`
  width: 100%;
  min-width: 100%;
`;

type MachineStatusViewTabsProps = {
  statusViews: ReportingMelcoMachineStatisticsModelsViewListItem[];
  userId?: string;
};

export const MachineStatusViewTabs: React.FC<MachineStatusViewTabsProps> = ({
  statusViews,
}) => {
  const { spacings } = DesignTokens;
  const [activeTooltip, setActiveTooltip] = useState<string | null>(null);

  const onChange = (key: string) => {
    console.log(key);
    setActiveTooltip(null);
  };

  let items: TabsProps["items"] = [];

  items = [];
  items = statusViews.map(
    (p: ReportingMelcoMachineStatisticsModelsViewListItem, i: number) => {
      let key = p?.id ?? i + "";
      let labelTitle = p?.name ?? "";
      return {
        key: key,
        label: labelTitle,
        children: (
          <MachineStatusView
            activeTooltip={activeTooltip}
            setActiveTooltip={setActiveTooltip}
            view={p}
          />
        ),
      };
    }
  );

  return (
    <>
      <FullWidthRow gutter={[spacings.middle, spacings.middle]}>
        <Tabs style={{ width: "100%" }} items={items} onChange={onChange} />
      </FullWidthRow>
    </>
  );
};
